import type { DateNavigator } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import RoundedButton from '@components/RoundedButton/RoundedButton';

import { OpenButtonWrapper } from './DateNavigator.style';

/**
 * VITALL-styled calendar-open button component for the routine scheduler toolbar
 */
const OpenButton = ({ ...props }: DateNavigator.OpenButtonProps) => {
  const { text, onVisibilityToggle } = props;
  return (
    <OpenButtonWrapper>
      <RoundedButton
        height="auto"
        onClick={() => onVisibilityToggle()}
        style={{ padding: '0 10px' }}
        variant="white"
      >
        {text}
      </RoundedButton>
    </OpenButtonWrapper>
  );
};

export default OpenButton;
